import React from 'react'
import PropTypes from 'prop-types'
import { Field, getIn } from 'formik'
import classNames from 'classnames'
import * as S from './styled'

import { Help } from '@peracto/peracto-ui'
import FormError from '../Error'

const Radio = ({ name, label, help, className, options, ...props }) => {
    return (
        <Field name={name}>
            {({ field, form }) => {
                let error = getIn(form.errors, name)

                if (error) {
                    const errorFieldName = label ? label : 'This'
                    error = error.replace(field.name, errorFieldName)
                }

                props.className = classNames('form-control', className)

                if (help) {
                    props['aria-describedby'] = `${name}Help`
                }

                if (!field.value) {
                    field.value = ''
                }

                return (
                    <div
                        className={classNames('form-group', {
                            'has-error': error,
                        })}
                    >
                        {label.length > 0 && <label className="!mb-0">{label}</label>}
                        {options.map(option => (
                            <React.Fragment key={option.value}>
                                <S.Radio>
                                    <input
                                        type="radio"
                                        {...props}
                                        {...field}
                                        name={name}
                                        value={option.value}
                                        disabled={form.isSubmitting}
                                        checked={field.value === option.value}
                                    />

                                    <span className="radio"></span>

                                    {option.label.length > 0 && option.label}
                                </S.Radio>

                                {option.help && (
                                    <Help id={`${option.value}Help`} help={option.help} />
                                )}
                            </React.Fragment>
                        ))}

                        {help && <Help id={`${name}Help`} help={help} />}

                        {error && <FormError error={error} />}
                    </div>
                )
            }}
        </Field>
    )
}

Radio.displayName = 'Radio'

Radio.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    help: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    options: PropTypes.array.isRequired,
    placeholder: PropTypes.string,
    className: PropTypes.string,
}

export default Radio
